<template>
  <!-- Shop Categories
    =============================================-->
  <section id="content" class="margintop100">
    <div class="content-wrap">
      <!-- จอขนาดเล็กกว่า 578px  -->
      <div class="no-show-big">
        <div class="row">
          <div style="width: 100%;" class="col-lg-8 col-md-6 col-xs-6 ">
            <div class="row">
              <div
                class="col-lg-12 col-12"
                style="margin-left:auto; margin-right:auto; padding:0 ;"
              >
                <img
                  @click="$router.push('/rental-list/ชุดว่ายน้ำ')"
                  style="cursor:pointer"
                  :src="getFullPath('dress.jpg')"
                  alt="Image"
                />
              </div>

              <div
                class="col-lg-6 col-6 norightpadding nosmpadding padding-right: 5px;"
              >
                <img
                  @click="$router.push('/rental-list/Accessories')"
                  style="cursor:pointer"
                  :src="getFullPath('accessories.jpg')"
                  alt="Image"
                />
              </div>

              <div
                class="px-1 col-lg-6 col-6 norightpadding nosmpadding"
                style="padding-left: 5px;"
              >
                <img
                  @click="$router.push('/rental-list/รองเท้า')"
                  style="cursor:pointer"
                  :src="getFullPath('shoes.jpg')"
                  alt="Image"
                />
              </div>

              <div class="w-100"></div>

              <div
                class="col-lg-12 col-12"
                style="margin-left:auto; margin-right:auto; padding:0 ;"
              >
                <img
                  @click="$router.push('/rental-list/รวมชุดเช่าแบรนด์')"
                  style="cursor:pointer"
                  :src="getFullPath('dressGallery.jpg')"
                  alt="Image"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- จอขนาดเล็กกว่า 578px  -->

      <!-- จอขนาดใหญ่กว่า 578px  -->
      <div class="no-show-small container clearfix">
        <div class="row">
          <div class="col-lg-8 col-md-6 col-md-6 ">
            <div class="row">
              <div class="col-lg-6 col-xs-12 col-12 norightpadding">
                <img
                  @click="$router.push('/rental-list/Accessories')"
                  style="cursor:pointer"
                  :src="getFullPath('accessories.jpg')"
                  alt="Image"
                />
              </div>

              <div
                class="col-lg-6 col-12 norightpadding nosmpadding"
                style="margin-bottom: 15px;"
              >
                <img
                  @click="$router.push('/rental-list/รองเท้า')"
                  style="cursor:pointer"
                  :src="getFullPath('shoes.jpg')"
                  alt="Image"
                />
              </div>

              <div class="w-100"></div>

              <div class="col-lg-12 norightpadding">
                <img
                  @click="$router.push('/rental-list/รวมชุดเช่าแบรนด์')"
                  style="cursor:pointer"
                  :src="getFullPath('dressGallery.jpg')"
                  alt="Image"
                />
              </div>
            </div>
          </div>

          <div
            class="col-lg-4 col-md-6 col-md-6 nosmpadding"
            style="padding-right:0; padding-left: 0; background-color: #ffd1d7; "
          >
            <img
              @click="$router.push('/rental-list/ชุดว่ายน้ำ')"
              style="cursor:pointer"
              :src="getFullPath('dress.jpg')"
              alt="Image"
            />
          </div>
        </div>
      </div>
      <!-- จอขนาดใหญ่กว่า 578px  -->
    </div>
  </section>
</template>
<script>
import myMixins from "@/mixins/myMixins.js";
export default {
  props: ["msg"],
  mixins: [myMixins],
  data() {
    return {
      welcome: "This is your profile",
    };
  },
  methods: {
    //    welcomeMessage() {
    //       console.log("Hello Method");
    //    }
  },
  components: {},
};
</script>

<style>
@media only screen and (min-width: 579px) {
  .no-show-big {
    display: none;
  }

  .margintop100 {
    margin-top: 100px;
  }
}
@media only screen and (max-width: 578px) {
  .no-show-small {
    display: none;
  }

  .margintop100 {
    margin-top: 0 !important;
  }
}
</style>